import axios from "axios";
import { API_BASE } from "../../config/env";
export const FETCH_ASSESSAPPLICATION_FULFILLED =
  "FETCH_ASSESSAPPLICATION_FULFILLED";
export const FETCH_ASSESSAPPLICATION_REJECTED =
  "FETCH_ASSESSAPPLICATION_REJECTED";
export const FETCH_ASSESSAPPLICATION_PENDING =
  "FETCH_ASSESSAPPLICATION_PENDING";
export const RESET_ASSESSAPPLICATION = "RESET_ASSESSAPPLICATION";

export function assessApplication(
  applicationId,
  isApproved,
  doctorRejectionReason
) {
  const token = localStorage.getItem("accessToken");

  return (dispatch) => {
    dispatch({
      type: "FETCH_ASSESSAPPLICATION",
      payload: axios({
        method: "post",
        url: `${API_BASE}/api/v3/second-opinion/assess-application`,
        data: { applicationId, isApproved, doctorRejectionReason },
        headers: {
          Authorization: "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69920"
        }
      }).then((result) => result.data)
    });
  };
}

export function resetAssessApplication() {
  return (dispatch) => {
    dispatch({
      type: "RESET_ASSESSAPPLICATION"
    });
  };
}
